module.exports = __webpack_public_path__ + "media/application/images/2018/twitter@2x-867034f56f47165b108eb209bed01583.png";